import { RootState } from '../../types.ts';

export const selectReconciliation = (state: RootState) => state.reconciliation;
